import * as yup from "yup";

export const homebuyerFormSchema = yup.object().shape({
  userEmail: yup
    .string()
    .required("Please enter email address")
    .email("Please enter valid email address"),
  userFirstName: yup.string().required("Please enter first name"),
  userLastName: yup.string().required("Please enter last name"),
  userRole: yup.string().required("Please select user role"),
});
